<template>
<div class="callback-form-modal-component">
  <dropdown-modal :offset="[0, 16]" :active.sync="active" strategy="fixed">
    <div class="callback-component-content" slot="content">
      <h4>Перезвоните мне</h4>
      <template v-if="stage === 'input'">
        <div class="form-group" :class="{ 'has-error': hasError }">
          <label for="callback-component-phone-input" class="form-control-label">
            Телефон
          </label>
          <phone-input id="callback-component-phone-input"
                       v-model="form.phone"
                       ref="phone"
                       @input:country="form.phone_country = $event"
          />
        </div>
        <button type="button" class="btn btn-sm btn-primary btn-rounded btn-block" :disabled="submissionDisabled" @click="sendCallbackRequest">
          <i class="fal fa-spinner fa-spin" v-if="formIsBusy"></i>
          Перезвонить
        </button>
      </template>
      <template v-if="stage === 'submitted'">
        <p class="callback-component-message">Спасибо, ваша заявка принята!</p>
        <button type="button" class="btn btn-sm btn-primary btn-rounded btn-block" @click="reset">
          Перезвонить
        </button>
      </template>
    </div>
    <template #toggle>
      <slot name="toggle"></slot>
    </template>
  </dropdown-modal>
</div>
</template>

<script>
import axios from '@/zenky'
import { mapGetters, mapActions } from 'vuex'
import DropdownModal from './DropdownModal'
import PhoneInput from '@/components/inputs/PhoneInput'
import zenkyEvents from '@/events'

export default {
  components: {
    DropdownModal,
    PhoneInput,
  },

  computed: {
    ...mapGetters({
      reCaptchaIsReady: 'recaptcha/isReady',
    }),

    submissionDisabled() {
      if (this.formIsBusy) {
        return true
      }

      return this.$store.state.recaptcha.actions.includes('callback_request') && !this.reCaptchaIsReady
    },
  },

  methods: {
    ...mapActions({
      getReCaptchaToken: 'recaptcha/getToken',
    }),

    reset() {
      this.form.phone = ''
      this.form.phone_country = 'RU'
      this.stage = 'input'
    },

    sendCallbackRequest() {
      if (this.formIsBusy) {
        return
      }

      this.hasError = false

      this.getReCaptchaToken('callback_request').then(token => {
        const form = {
          phone: this.form.phone,
          phone_country: this.form.phone_country,
        }

        if (token) {
          form.recaptcha = { token }
        }

        this.formIsBusy = true

        axios.post('interactions/callback', form)
          .then(({ data }) => {
            this.formIsBusy = false
            this.stage = 'submitted'

            this.$root.sharedEventBus.$emit(zenkyEvents.CALLBACK_SUBMITTED, {
              phone: this.form.phone,
              phone_country: this.form.phone_country,
            })
          })
          .catch(err => this.formIsBusy = false)
      })
    },
  },

  data() {
    return {
      active: false,
      formIsBusy: false,
      hasError: false,
      stage: 'input',

      form: {
        phone: '',
        phone_country: '',
      },
    }
  }
}
</script>

<style lang="less">
.callback-form-modal-component {
  .callback-component-content {
    @apply p-4;

    h4 {
      @apply mb-4 font-bold;
    }

    .callback-component-message {
      @apply mb-4;
    }

    .form-group {
      @apply mb-4;
    }
  }
}
</style>
